import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { ButtonEx, FlexRow } from '@xylabs/sdk-react'

import InventorySlotViewer from './InventorySlotViewer'
import Item from './Item'
import ItemRarity from './ItemRarity'
import ItemSlot from './ItemSlot'
import ItemSlotType from './ItemSlotType'

interface Props {
  onCancel?: () => void
  onSelect?: (selected?: Item) => void
  open?: boolean
  title?: string
}

const inventory: Item[] = [
  { moniker: 'energy-dish', name: 'Energy Dish', rarity: ItemRarity.Poor },
  { moniker: 'data-sink', name: 'Data Sink', rarity: ItemRarity.Poor },
  { moniker: 'matter-mill', name: 'Matter Mill', rarity: ItemRarity.Poor },
]

const InventorySelectDialogOpen: React.FC<Props> = (props) => {
  const { onSelect, onCancel, title = 'Select Tool', open = false } = props

  const slots: ItemSlot[] = inventory.map((item) => {
    return {
      item,
      type: ItemSlotType.Equippable,
    }
  })

  return (
    <Dialog onClose={onCancel} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <FlexRow flexWrap="wrap">
          {slots.map((slot, index) => {
            return (
              <FlexRow key={index} padding={1}>
                <InventorySlotViewer itemSlot={slot} onSelected={() => onSelect?.(slot?.item)} />
              </FlexRow>
            )
          })}
        </FlexRow>
      </DialogContent>
      <DialogActions>
        <FlexRow width="100%" justifyContent="space-between">
          <ButtonEx onClick={onCancel} variant="text">
            Cancel
          </ButtonEx>
          <ButtonEx onClick={() => onSelect?.()} variant="text">
            Remove
          </ButtonEx>
        </FlexRow>
      </DialogActions>
    </Dialog>
  )
}

const InventorySelectDialog: React.FC<Props> = (props) => {
  const { open } = props
  if (open) {
    return <InventorySelectDialogOpen {...props} />
  } else {
    return null
  }
}

export default InventorySelectDialog
